import styled from '@mui/system/styled'

export const StyledPreview = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: 254,
  height: 160,
  [theme.breakpoints.down('sm')]: { width: 152, height: 96 },
}))
